import ApiService from '@/api/service';
import {
  FETCH_MOVES_URL,
  GET_MOVE_DETAILS,
  ASSIGN_DEVICE_TO_MOVE_URL,
  REMOVE_ASSIGNED_DEVICE_URL,
} from '@/api/constants';

export default {
  get(params) {
    return ApiService.query(FETCH_MOVES_URL, params);
  },
  getOne(id) {
    return ApiService.get(GET_MOVE_DETAILS.replace(':id', id))
  },
  assignDevice(moveId, deviceId) {
    return ApiService.patch(
      ASSIGN_DEVICE_TO_MOVE_URL
        .replace(':moveId', moveId)
        .replace(':deviceId', deviceId)
    );
  },
  removeAssignedDevice(moveId) {
    return ApiService.patch(
      REMOVE_ASSIGNED_DEVICE_URL
        .replace(':moveId', moveId)
    );
  }
}